import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MdArrowLeft, MdArrowRight, MdExpandMore } from 'react-icons/md';
import { Box, IconButton, Menu, Tooltip, Typography } from '@mui/material';

import { linkDisplayStyles } from '../../styles';
import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import {
    getAllSimilarLinks,
    getLinkDisplayData,
    getUniqueContentLinks,
} from 'GeminiViewerComponent/features/globals/visibilitySlice';
import { config } from 'gemini-config';

const DisplayModeButton = ({ viewType, onClick }) => (
    <Tooltip title={viewType.display_name}>
        <IconButton
            id={`link-display-option-${viewType.id}-button`}
            onClick={onClick}
            style={{ padding: 0, backgroundColor: 'lightgray' }}
        >
            {viewType.imageIcon ? (
                <img src={viewType.imageIcon} alt={`${viewType.display_name} view`} height={'22px'} width={'22px'} />
            ) : (
                viewType.icon
            )}
        </IconButton>
    </Tooltip>
);

export const LinkPagination = ({
    handleLinkNavigation,
    currentActiveLinkIndex,
    setCurrentActiveLinkIndex,
    displayOptions,
    onChangeDisplayOption,
}) => {
    const theme = useSelector(selectActiveTheme);
    const classes = linkDisplayStyles(theme);
    const allContentLinks = useSelector(getUniqueContentLinks);
    const linkData = useSelector(getLinkDisplayData);
    const [displayOptionMenuEl, setDisplayOptionMenuEl] = useState(null);

    const isDisplayMenuOption = !!displayOptionMenuEl;

    useEffect(() => {
        if (allContentLinks?.length > 0 && Object.keys(linkData).length > 0) {
            setCurrentActiveLinkIndex(allContentLinks.findIndex((link) => link.link_id === linkData?.link_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkData, allContentLinks]);

    return (
        <>
            <Box className={classes.linkTitleWrapper}>
                <Typography className={classes.linkTitleText}>{linkData?.display_name}</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'absolute',
                        right: 0,
                    }}
                >
                    {allContentLinks?.length > 1 && (
                        <Typography className={classes.linkIndex}>
                            {`${currentActiveLinkIndex + 1} / ${allContentLinks?.length}`}
                        </Typography>
                    )}
                    {config.modeType === 'viewer' && displayOptions?.length > 0 && (
                        <>
                            <Tooltip title="Display options">
                                <IconButton
                                    size="small"
                                    sx={{ mx: 1, p: 0 }}
                                    id="display-options-button"
                                    aria-controls={isDisplayMenuOption ? 'display-options-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={isDisplayMenuOption ? 'true' : undefined}
                                    onClick={(e) => setDisplayOptionMenuEl(e.target)}
                                >
                                    <MdExpandMore color="white" size="30" />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="display-options-menu"
                                anchorEl={displayOptionMenuEl}
                                open={isDisplayMenuOption}
                                onClose={() => setDisplayOptionMenuEl(null)}
                                MenuListProps={{
                                    'aria-labelledby': 'display-options-button',
                                    className: classes.displayOptionsMenu,
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                {displayOptions.map((mode) => (
                                    <DisplayModeButton
                                        key={mode.id}
                                        viewType={mode}
                                        onClick={() => onChangeDisplayOption?.(mode.id)}
                                    />
                                ))}
                            </Menu>
                        </>
                    )}
                </Box>
            </Box>
            {allContentLinks?.length > 1 && (
                <Box className={classes.navigationButtonWrapper}>
                    <IconButton
                        id="viewer_inline_prev-btn"
                        className={classes.navigationButton}
                        style={{ left: '20px' }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            handleLinkNavigation(currentActiveLinkIndex - 1);
                        }}
                        disabled={currentActiveLinkIndex === 0}
                    >
                        <MdArrowLeft className="react-icon" />
                    </IconButton>
                    <IconButton
                        id="viewer_inline_next-btn"
                        className={classes.navigationButton}
                        style={{ right: '20px' }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                            handleLinkNavigation(currentActiveLinkIndex + 1);
                        }}
                        disabled={currentActiveLinkIndex === allContentLinks.length - 1}
                    >
                        <MdArrowRight className="react-icon" />
                    </IconButton>
                </Box>
            )}
        </>
    );
};
